import { platformBrowser } from '@angular/platform-browser';
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { NgBootstrapModule } from './app.module';
import { loadAuthSettings } from "./commons/configs/loadAuthSettings";
import { Auth0Client } from '@auth0/auth0-spa-js';
import getEnvironmentSettings from './commons/configs/env-conf-loader';

//@ts-ignore
window.CMS_BUILD_DATE = CMS_BUILD_DATE;

_documentReady();

function _documentReady(envName = getEnvironmentSettings().name) {
  loadAuthSettings(envName)
    .then((client) => {
      if (envName != "Localhost") { enableProdMode(); }
      return platformBrowser([{
        provide: Auth0Client,
        useValue: client
      }])
        .bootstrapModule(
          NgBootstrapModule,
          {
            applicationProviders: [provideZoneChangeDetection()],
          }
        );
    })
    .catch(err => console.error(err))
}
